import React, { Component } from "react"
import "./Header.css"

class Header extends Component {

    render() {
        return(
            <div className="intro">
            <img src="https://res.cloudinary.com/dkhiieq9p/image/upload/v1594916168/Screen_Shot_2020-07-16_at_12.16.02_PM_vf5rzz.png" alt="profile pic"></img>
            <div className="title">
            <h1>Jake Pressman</h1>
            <h2>Full Stack Software Engineer • Web Developer</h2>
            <p>I'm a Senior Web Developer with a background that sets me apart: before I wrote a single line of code, I was studying the intersection of music, business, and human connection.</p>
            </div>
            </div>
        )
    }
}

export default Header
